import React from 'react'
import { calcularIMC } from 'util/atendimento'
import { toDate } from 'util/date/formatDate'
import { formatNumber } from 'util/number'
import { AlertImc } from 'view/atendimentos/detail/soap/aside/medicoes/components/AlertImc'
import { ParticipanteModel } from 'view/atividade-coletiva/model-atividadeColetiva'

interface ParticipanteImcAlertProps {
  participante: ParticipanteModel
  dataAtividade: LocalDate | number
}

export const ParticipanteImcAlert = ({ participante, dataAtividade }: ParticipanteImcAlertProps) => {
  if (participante.peso && participante.altura) {
    const imc = formatNumber(calcularIMC(participante.peso, participante.altura))
    const cidadao = participante.cidadao ?? participante.cidadaoParticipante

    return (
      <AlertImc
        dataMedicao={toDate(dataAtividade).getTime()}
        imc={imc}
        dataNascimento={cidadao.dataNascimento}
        sexo={cidadao.sexo}
      />
    )
  }

  return <></>
}
